
import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-16">
        <div className="space-y-8">
          <h1 className="text-4xl font-serif font-bold text-stone-900">İletişime Geçin</h1>
          <p className="text-stone-500 font-medium">Sorularınız, önerileriniz veya iş birlikleri için bize her zaman ulaşabilirsiniz.</p>
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center text-amber-800"><Phone size={24} /></div>
              <div><p className="font-bold">Telefon</p><p className="text-sm text-stone-500">+90 212 000 00 00</p></div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center text-amber-800"><Mail size={24} /></div>
              <div><p className="font-bold">E-posta</p><p className="text-sm text-stone-500">hello@luminahome.com</p></div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-amber-50 rounded-xl flex items-center justify-center text-amber-800"><MapPin size={24} /></div>
              <div><p className="font-bold">Adres</p><p className="text-sm text-stone-500">İstanbul, Türkiye</p></div>
            </div>
          </div>
        </div>
        <div className="bg-white p-10 rounded-[3rem] border border-stone-100 shadow-xl">
          <form className="space-y-6">
            <input type="text" placeholder="Adınız" className="w-full bg-stone-50 border border-stone-200 rounded-2xl py-4 px-6 focus:ring-2 focus:ring-amber-500 outline-none" />
            <input type="email" placeholder="E-posta" className="w-full bg-stone-50 border border-stone-200 rounded-2xl py-4 px-6 focus:ring-2 focus:ring-amber-500 outline-none" />
            <textarea rows={4} placeholder="Mesajınız" className="w-full bg-stone-50 border border-stone-200 rounded-2xl py-4 px-6 focus:ring-2 focus:ring-amber-500 outline-none resize-none"></textarea>
            <button className="w-full bg-stone-900 text-white py-4 rounded-2xl font-bold hover:bg-amber-800 transition-all shadow-lg">Gönder</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
